var ezdia;
(function (ezdia) {
    function rowMarkup(_a) {
        var label = _a.label, content = _a.content, _b = _a.cls, cls = _b === void 0 ? '' : _b;
        return "<div data-row=\"row\" class=\"info-row " + cls + "\">\n      <div class=\"info-label\">" + label + "</div>\n      <div data-row=\"input\">" + content + "</div>\n    </div>";
    }
    function infoMarkup(content, imagePrev) {
        return "<div class=\"rep-info\">\n      <div class=\"row\">\n        <div class=\"text-content col-md-5\">" + content + "</div>\n        <div class=\"img-content col-md-7\">\n          " + imagePrev + "\n        </div>\n      </div>\n    </div>";
    }
    function adminFormMarkup(content) {
        return "<div class=\"rep-info rep-subscription-info\">\n      " + content + "\n    </div>";
    }
    function imgPreviewMarkup(_a) {
        var thumbnailUrl = _a.thumbnailUrl;
        return "<img class=\"img-responsive\" src=\"" + thumbnailUrl + "\">";
    }
    function reportDownloadRowMarkup(reportData) {
        if (reportData === void 0) { reportData = []; }
        return "" + reportData
            .map(function (_a) {
            var label = _a.label, date = _a.date, email = _a.email, link = _a.link;
            return "<tr>\n          <td>" + label + "</td>\n          <td>" + date + "</td>\n          <td>" + email + "</td>\n          <td><a href=" + link + "><i class=\"fa fa-download\"></i> Download</a></td>\n        </tr>";
        })
            .join('');
    }
    function reportDownloadMarkup(reportData) {
        return "<div class=\"rep-info rep-subscription-info\">\n      <div data-row=\"row\" class=\"info-row\">\n        <div class=\"info-label\">Previous Updates</div>\n        <div data-row=\"input\">\n        <table class=\"table table-striped table-hover\">\n          <thead>\n            <tr>\n              <th>Report Name</th>\n              <th>Date</th>\n              <th>Email</th>\n              <th></th>\n            </tr>\n          </thead>\n          <tbody>" + reportDownloadRowMarkup(reportData) + "</tbody>\n        <table></div>\n      </div>\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.reporting = {
            rowMarkup: rowMarkup,
            infoMarkup: infoMarkup,
            imgPreviewMarkup: imgPreviewMarkup,
            adminFormMarkup: adminFormMarkup,
            reportDownloadMarkup: reportDownloadMarkup
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
